module.exports = __webpack_public_path__ + "static/img/icon-work.8f20a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-work.png
// module id = PHk3
// module chunks = 0